import amplitude from 'amplitude-js';
var initAmplitude = function (_a) {
    var ApiKey = _a.ApiKey;
    amplitude.getInstance().init(ApiKey);
};
export default initAmplitude;
